import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environments';

@Injectable({
  providedIn: 'root'
})
export class StudioService {

  constructor(private readonly http: HttpClient) { }

  
  getOcrData(file:any, categoryId?: string): Observable<any> {
    let url = environment.API_URL + `/v1/studio`;
    const formData: FormData = new FormData();
    formData.append('file', file, file.name);
    if (categoryId) {
      formData.append('categoryId', categoryId);
    }
    return this.http.post(url, formData);
  }

  createStudioMetadata(payload: { 
      metadata: Array<{
      label: string;
      fieldType: string;
    }>;
    keywords: string[];
    category: string;
  }): Observable<any> {
    const url = `${environment.API_URL}/v1/studio-metadata`;
    return this.http.post(url, payload);
  }

  getStudioMetadata(payload: any): Observable<any> {
    const url = `${environment.API_URL}/v1/studio-metadata`;
    return this.http.get(url, {params: payload});
  }

  getUserCredits(): Observable<any> {
    return this.http.get(`${environment.API_URL}/v1/studio-user-credits`);
  }
}
